import Swal from "sweetalert2";

export const alerts = {
    basic: {
        success: <T>(afterFn?: (data: T) => unknown) => {
            return (data: T) => {
                Swal.fire({
                    icon: "success",
                    title: "Berhasil",
                }).then(() => afterFn?.(data));
            };
        },
        failure: (afterFn?: () => unknown) => {
            return (message?: string) => {
                Swal.fire({
                    icon: "error",
                    title: "Gagal",
                    text: message,
                }).then(afterFn);
            };
        },
    },
    message: {
        success: (message: string, afterFn?: () => unknown) => {
            return () => {
                Swal.fire({
                    icon: "success",
                    title: message,
                }).then(afterFn);
            };
        },
    },
    confirm: {
        warning: async (title: string) => {
            const dialog = await Swal.fire({
                icon: "warning",
                title: title,
                allowOutsideClick: true,
                confirmButtonColor: "red",
                showCancelButton: true,
                cancelButtonText: "Batal",
            });

            return dialog.isConfirmed;
        },
        warningText: async ({ title, text }: { title: string; text: string }) => {
            const dialog = await Swal.fire({
                icon: "warning",
                title: title,
                text: text,
                allowOutsideClick: true,
                confirmButtonColor: "red",
                showCancelButton: true,
                cancelButtonText: "Batal",
            });

            return dialog.isConfirmed;
        },
    },
    form: {
        confirmRemove: async (name: string | undefined) => {
            const dialog = await Swal.fire({
                icon: "warning",
                title: `Hapus ${name ?? "data ini"}?`,
                showCancelButton: true,
                confirmButtonColor: "red",
                cancelButtonText: "Batal",
            });

            return dialog.isConfirmed;
        },
        incomplete: (message?: string) => {
            Swal.fire({
                icon: "error",
                title: message ?? "Data tidak lengkap",
            });
        },
    },
};
